export default __webpack_public_path__ + "static/media/swipe.c0c21c3a.mp3";